import React from 'react';

const LiveCredentialInfoLayer = () => {
    if (window.location.host.includes('aurumtours.de') || process.env.VITE_ENV !== 'production') {
        return null;
    } else {
        let liveCredentialInfoLayerStyling = {
            container: {
                background: '#cd2026',
                color: 'white',
                padding: '4px',
                fontSize: '14px',
                textAlign: 'center',
                position: 'relative',
                zIndex: 1,
            },
        };
        return (
            <div className="info-layer" style={liveCredentialInfoLayerStyling.container}>
                Achtung! Es sind aktuell Live-Credentials hinterlegt. Agiere mit Bedacht.
            </div>
        );
    }
};

export default LiveCredentialInfoLayer;
